import React from 'react';
import { Modal, Row, Col, Avatar, Typography, Divider, Card, Space, Tag } from 'antd';
import { UserOutlined, PhoneOutlined, EnvironmentOutlined, CloseOutlined, WarningOutlined } from '@ant-design/icons';
import './ReportDetailsModal.css';

const { Text, Title } = Typography;

const ReportDetailsModal = ({ isModalVisible, setIsModalVisible, selectedReport }) => {

  const getReason = (reason) => {
    var str = "";
    if (reason) {
      for (var i = 0; i < reason.length; i++) {
        if (reason[i] === '$') {
          str = str + ", ";
        } else {
          str = str + reason[i];
        }
      }
      return str;
    }
  };

  return (
    <Modal
      open={isModalVisible}
      onCancel={() => setIsModalVisible(false)}
      footer={null}
      width={1000}
      centered
      closeIcon={<CloseOutlined style={{ fontSize: '18px', color: '#666' }} />}
      className="report-details-modal"
    >
      {selectedReport && (
        <div className="report-modal-content">
          {/* Header */}
          <div className="modal-header">
            <div className="header-icon">
              <WarningOutlined style={{ fontSize: '28px', color: '#ff4d4f' }} />
            </div>
            <div>
              <Title level={3} style={{ margin: 0, color: '#1a1a1a' }}>
                Report Details
              </Title>
              <Text type="secondary" style={{ fontSize: '14px' }}>
                Review the reported user information and complaint details
              </Text>
            </div>
          </div>

          <Divider style={{ margin: '24px 0' }} />

          {/* 🔄 REPORTED ON (Now showing REPORTED BY data) */}
          <Card
            className="info-card reported-to-card"
            style={{ marginBottom: '24px', borderLeft: '4px solid #ff4d4f' }}
          >
            <div className="card-label">
              <Tag color="error" style={{ fontSize: '12px', fontWeight: 600 }}>
                REPORTED ON
              </Tag>
            </div>

            <Row gutter={24} align="middle" style={{ marginTop: '16px' }}>
              <Col>
                <Avatar
                  src={selectedReport.reportedby_user_logo}
                  size={80}
                  icon={<UserOutlined />}
                  style={{
                    border: '3px solid #fff',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                  }}
                />
              </Col>
              <Col flex="auto">
                <Space direction="vertical" size={4} style={{ width: '100%' }}>
                  <Title level={4} style={{ margin: 0, color: '#1a1a1a' }}>
                    {selectedReport.reportedby_user_company_name}
                  </Title>
                  <Space size={8}>
                    <Tag color="green">
                      {selectedReport.reportedby_user_role_name}
                    </Tag>
                    <Tag color="purple">
                      {selectedReport.reportedby_user_legal_entity}
                    </Tag>
                  </Space>
                  <Space direction="vertical" size={8} style={{ marginTop: '12px' }}>
                    <div className="info-row">
                      <EnvironmentOutlined style={{ color: '#1890ff', marginRight: '8px' }} />
                      <Text style={{ color: '#595959' }}>
                        {selectedReport.reportedby_user_address}
                      </Text>
                    </div>
                    <div className="info-row">
                      <PhoneOutlined style={{ color: '#52c41a', marginRight: '8px' }} />
                      <Text strong style={{ color: '#262626' }}>
                        {selectedReport.reportedby_user_mobile}
                      </Text>
                    </div>
                  </Space>
                </Space>
              </Col>
            </Row>
          </Card>

          {/* 🔄 REPORTED BY (Now showing REPORTED ON data) */}
          <Card
            className="info-card reported-by-card"
            style={{ marginBottom: '24px', borderLeft: '4px solid #1890ff' }}
          >
            <div className="card-label">
              <Tag color="processing" style={{ fontSize: '12px', fontWeight: 600 }}>
                REPORTED BY
              </Tag>
            </div>

            <Row gutter={24} align="middle" style={{ marginTop: '16px' }}>
              <Col>
                <Avatar
                  src={selectedReport.user_logo}
                  size={80}
                  icon={<UserOutlined />}
                  style={{
                    border: '3px solid #fff',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                  }}
                />
              </Col>
              <Col flex="auto">
                <Space direction="vertical" size={4} style={{ width: '100%' }}>
                  <Title level={4} style={{ margin: 0, color: '#1a1a1a' }}>
                    {selectedReport.user_company_name}
                  </Title>
                  <Tag color="blue" style={{ width: 'fit-content' }}>
                    {selectedReport.user_role_name}
                  </Tag>
                  <Space direction="vertical" size={8} style={{ marginTop: '12px' }}>
                    <div className="info-row">
                      <EnvironmentOutlined style={{ color: '#1890ff', marginRight: '8px' }} />
                      <Text style={{ color: '#595959' }}>
                        {selectedReport.user_address}
                      </Text>
                    </div>
                    <div className="info-row">
                      <PhoneOutlined style={{ color: '#52c41a', marginRight: '8px' }} />
                      <Text strong style={{ color: '#262626' }}>
                        {selectedReport.user_mobile}
                      </Text>
                    </div>
                  </Space>
                </Space>
              </Col>
            </Row>
          </Card>

          {/* Reason Section */}
          <Card
            className="reason-card"
            style={{
              backgroundColor: '#fff7e6',
              borderLeft: '4px solid #faad14',
            }}
          >
            <Space direction="vertical" size={8} style={{ width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <WarningOutlined style={{ color: '#faad14', fontSize: '18px' }} />
                <Text strong style={{ fontSize: '16px', color: '#262626' }}>
                  Reason for Report
                </Text>
              </div>
              <Text
                style={{
                  fontSize: '15px',
                  color: '#434343',
                  lineHeight: '1.6',
                  display: 'block',
                  paddingLeft: '26px',
                }}
              >
                {getReason(selectedReport.fld_reason_text)}
              </Text>
            </Space>
          </Card>
        </div>
      )}
    </Modal>
  );
};

export default ReportDetailsModal;
